/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from "react"
import { motion } from "framer-motion"

import '../grid.css'
import { Link } from 'react-router-dom'
import { ProjectCard } from '../Components/ProjectCard'
import { ProjectCardMobile } from '../Components/ProjectCardMobile'

import { NavBar } from '../Components/NavBar'

import { Grid, Row, Col } from "react-flexbox-grid"
//adding support for IBM Plex Mono as a font.
import ImageWizehire from '../Assets/Wizehire/Wizehire-big-mockup.png'
import ImagePd from '../Assets/PagerDuty/PD-mock.png'
import ImageMango from '../Assets/Mango/Mango-mockup.png'
import ImageVenmo from '../Assets/Venmo/Venmo-mockup.png'
import { ReactComponent as Twitter } from '../Assets/Icons/twitter.svg'
import { ReactComponent as Github } from '../Assets/Icons/github.svg'
import { ReactComponent as Dribbble } from '../Assets/Icons/dribbble-ball-mark.svg'
import { ReactComponent as Instagram } from '../Assets/Icons/instagram.svg'
import { ReactComponent as LinkedIn } from '../Assets/Icons/Linkedin.svg'
import "fontsource-inter"
import "fontsource-space-grotesk"
import "fontsource-jost"
import useMediaQuery from "../Components/useMediaQuery"
//adding CSS styles inline, as we dok=

//tracking window width 

const styles = {
    Page: { backgroundColor: "#27292D" },

    HeroTitle: {
        fontFamily: `"IBM Plex Mono", monospace`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "3.5em",
        letterSpacing: "0.0625em",
        lineHeight: 1.2,
        fontWeight: 500,
        fontStyle: "normal",

    } as const,

    HeroDescription: {
        fontFamily: `"Larsseit", sans-serif`,
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: "1.25em",
        letterSpacing: "0.00125em",
        lineHeight: 1.65,
    } as const,


    //styles for inline links
    InlineLink: {

    } as const,

    //styles for social links
    SocialContainer: {
        paddingTop: 32,
    } as const,

    IconContainer: {
        marginRight: 16,
        marginTop: 32,
        display: "flex-horizontal",
    },

    SocialContainerIcon: {
        initial: {
            opacity: 0.45,

        },

        hover: {
            opacity: 1,
            transition: {
                type: "ease",
                ease: [0.22, 1, 0.36, 1],
                duration: 0.15,
            }
        }

    } as const,




}

const upperVariants = {
    initial: {
        opacity: 1,
        scale: 1,
    },
    in: {
        opacity: 1,
        scale: 1,
        transition: {
            type: "tween",
            ease: [0.22, 1, 0.36, 1],
            delayChildren: 0.125,
            staggerChildren: 0.85,

        },
    },
    out: {
        opacity: 1,
        scale: 1,
        staggerChildren: 0.025,
    }
}

//page transitions for animating into homepage
const HeroVariants = {
    initial: {
        opacity: 0,
        scale: 1,
        y: "-120%",

    },
    in: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
            type: "ease",
            ease: [0.22, 1, 0.36, 1],
            duration: 0.75,

        },

    },
    out: {
    }
};


const CardVariants = {
    initial: {
        opacity: 1,
        scale: 1,
        x: "30%",

    },
    in: {
        opacity: 1,
        x: 0,
        scale: 1,
        transition: {
            x: { stiffness: 100, velocity: -100 },
            type: "ease",
            ease: [0.22, 1, 0.36, 1],
            duration: 1.5,
            staggerChildren: 0.85,
            staggerDirection: 1,
        },
    },
    out: {
        opacity: 0,
        x: "-80%",
        scale: 1,
        transition: {
            x: { stiffness: 100, velocity: -100 },
            type: "ease",
            ease: [0.22, 1, 0.36, 1],
            duration: 1.5,
            staggerChildren: 0.85,
            staggerDirection: 1,
        }
    }
};






function Home(): JSX.Element {
    let isMobile = useMediaQuery('(max-width: 600px)')
    return (
        <motion.div
            initial="initial"
            animate="in"
            exit="out"
            variants={upperVariants}
            layout
        >
            <Grid fluid>
                <Row top="lg">
                    <Col lg={5} lgOffset={2} xs={11} xsOffset={1}>
                        <motion.div
                            initial="initial"
                            animate="in"
                            exit="out"
                            variants={HeroVariants}
                        >
                            <p style={styles.HeroTitle}>Chaitanya Prashant</p>
                            <p style={styles.HeroDescription}>What’s up! I’m an LA based designer finishing up my degree at UCSD (Design and CS), and most recently worked as a product design intern at Curology, helping make skincare accessible for all. </p>
                            <p style={styles.HeroDescription}>I’m looking for freelance opportunities in the fall and winter, and new grad product design roles December 2020 onwards. Feel free to look at my work below, view this fancy piece of paper and if you like what you see, hit my line!</p>
                        </motion.div>
                        <motion.div
                            style={styles.SocialContainer}
                            variants={HeroVariants}
                        >
                            <motion.a
                                style={styles.IconContainer}
                                variants={styles.SocialContainerIcon}
                                initial="initial"
                                whileHover="hover"

                                href="http://twitter.com/chints98"
                                target="_blank">
                                <Twitter
                                    fill="#FFFFFF"
                                />
                            </motion.a>

                            <motion.a
                                style={styles.IconContainer}
                                variants={styles.SocialContainerIcon}
                                initial="initial"
                                whileHover="hover"

                                href="https://www.github.com/chints98"
                                target="_blank">
                                <Github
                                    fill="#FFFFFF"
                                />
                            </motion.a>

                            <motion.a
                                style={styles.IconContainer}
                                variants={styles.SocialContainerIcon}
                                initial="initial"
                                whileHover="hover"

                                href="https://dribbble.com/chints98"
                                target="_blank">
                                <Dribbble
                                    fill="#FFFFFF"
                                />
                            </motion.a>

                            <motion.a
                                style={styles.IconContainer}
                                variants={styles.SocialContainerIcon}
                                initial="initial"
                                whileHover="hover"

                                href="https://www.linkedin.com/in/chaitanyaprashant"
                                target="_blank">
                                <LinkedIn
                                    fill="#FFFFFF"
                                />
                            </motion.a>

                            <motion.a
                                style={styles.IconContainer}
                                variants={styles.SocialContainerIcon}
                                initial="initial"
                                whileHover="hover"

                                href="https://instagram.com/chints98"
                                target="_blank">
                                <Instagram
                                    fill="#FFFFFF"
                                />
                            </motion.a>



                        </motion.div>

                    </Col>
                    <Col lg={1} lgOffset={2} xs={3} xsOffset={2} style={{ marginTop: 64 }}>
                        <Link to='/'>
                            <NavBar />
                        </Link>
                    </Col>
                    <Col lg={1} xs={4} style={{ marginTop: 64 }}>
                        <Link to='/Pages/About'>
                            <NavBar
                                Active={false}
                                Text="About Me"
                            />

                        </Link>
                    </Col>


                </Row>

                <motion.div
                    initial="initial"
                    animate="in"
                    exit="out"
                    variants={CardVariants}
                >
                    <Row middle="lg" style={{ marginTop: 64 }}>
                        <Col xs={12}>
                            <Row start="lg">
                                <Col lgOffset={2} lg={3}>


                                    <Link to='/Pages/CurologyCadence'>
                                        {isMobile ?
                                            <ProjectCardMobile
                                                ProjTitle={"Subscription Cadence"}
                                            ></ProjectCardMobile>
                                            :
                                            <ProjectCard
                                                ProjTitle={"Subscription Cadence"}
                                            ></ProjectCard>

                                        }

                                    </Link>

                                </Col>
                                <Col lgOffset={2} lg={3}>

                                    <Link to='/Pages/Wizehire'>
                                        {isMobile ?
                                            <ProjectCardMobile
                                                Background={"#27292D"}
                                                Theme={"#84AF43"}
                                                ProjectImage={ImageWizehire}
                                                ProjTitle={"Designing for growth at Wizehire"}
                                                ProjDescription={"One of the projects I worked on over the summer of 2019 was to design a way to increase new user growth through our existing referral program within the product, and identify new areas of impact for the feature."}
                                                TagWork={"Product Design"}
                                                TagLocation={"Wizehire"}
                                            ></ProjectCardMobile>
                                            :
                                            <ProjectCard
                                                Background={"#27292D"}
                                                Theme={"#84AF43"}
                                                ProjectImage={ImageWizehire}
                                                ProjTitle={"Designing for growth at Wizehire"}
                                                ProjDescription={"One of the projects I worked on over the summer of 2019 was to design a way to increase new user growth through our existing referral program within the product, and identify new areas of impact for the feature."}
                                                TagWork={"Product Design"}
                                                TagLocation={"Wizehire"}
                                            ></ProjectCard>


                                        }
                                    </Link>


                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row middle="lg" style={{ marginTop: 64 }}>
                        <Col xs={12}>
                            <Row start="lg">
                                <Col lgOffset={2} lg={3}>

                                    <Link to='/Pages/CurologyTimeline'>
                                        {isMobile ?
                                            <ProjectCardMobile
                                                ProjTitle={"Internal Provider Timeline"}
                                            ></ProjectCardMobile>
                                            :
                                            <ProjectCard
                                                ProjTitle={"Internal Provider Timeline"}
                                            ></ProjectCard>


                                        }
                                    </Link>
                                </Col>
                                <Col lgOffset={2} lg={3}>
                                    <Link to='/Pages/PagerDuty'>
                                        {isMobile ?
                                            <ProjectCardMobile
                                                Theme={"#41BC00"}
                                                ProjectImage={ImagePd}
                                                ProjTitle={"PagerDuty Teams UX internship"}
                                                ProjDescription={"I spent the summer of 2018 interning at PagerDuty, where I redesigned a feature for the core enterprise product to better represent administrative data within teams for incident management, and allow admins to make incident management decisions with more confidence."}
                                                TagWork={"Product Design"}
                                                TagLocation={"PagerDuty"}
                                            ></ProjectCardMobile>
                                            :
                                            <ProjectCard
                                                Theme={"#41BC00"}
                                                ProjectImage={ImagePd}
                                                ProjTitle={"PagerDuty Teams UX internship"}
                                                ProjDescription={"I spent the summer of 2018 interning at PagerDuty, where I redesigned a feature for the core enterprise product to better represent administrative data within teams for incident management, and allow admins to make incident management decisions with more confidence."}
                                                TagWork={"Product Design"}
                                                TagLocation={"PagerDuty"}
                                            ></ProjectCard>
                                        }
                                    </Link>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row middle="lg" style={{ marginTop: 64 }}>
                        <Col xs={12}>
                            <Row start="lg">
                                <Col lgOffset={2} lg={3}>
                                    <Link to='/Pages/Mango'>
                                        {isMobile ?
                                            <ProjectCardMobile
                                                ProjTitle={"Redesigning Mango Health"}
                                                ProjectImage={ImageMango}
                                                TagColor={"#2F80ED"}
                                                Theme={"#EF6C3C"}
                                                ProjDescription={"A redesign of Mango Health for the KP Fellows Application. I focused on information and visual design, using guerilla research to discover potential pain points, scope for improvements to the home surface and redesign the app to be more goal oriented, less information dense. Result - Named KP Fellows finalist for 2019."}
                                                TagWork={"Side Project"}
                                                TagLocation={"UX/Visual design"}
                                            ></ProjectCardMobile>

                                            :
                                            <ProjectCard
                                                ProjTitle={"Redesigning Mango Health"}
                                                ProjectImage={ImageMango}
                                                TagColor={"#2F80ED"}
                                                Theme={"#EF6C3C"}
                                                ProjDescription={"A redesign of Mango Health for the KP Fellows Application. I focused on information and visual design, using guerilla research to discover potential pain points, scope for improvements to the home surface and redesign the app to be more goal oriented, less information dense. Result - Named KP Fellows finalist for 2019."}
                                                TagWork={"Side Project"}
                                                TagLocation={"UX/Visual design"}
                                            ></ProjectCard>

                                        }
                                    </Link>
                                </Col>
                                <Col lgOffset={2} lg={3}>
                                    <Link to='/Pages/CurologyTimeline'>
                                        {isMobile
                                            ?

                                            <ProjectCardMobile
                                                Theme={"#5d93d8"}
                                                TagColor={"#2F80ED"}
                                                ProjectImage={ImageVenmo}
                                                ProjTitle={"Redesigning Venmo's payments flow"}
                                                ProjDescription={"Redesigning Venmo to be more efficient in terms of transactions, as well as conceptualizing a potential recurring payments feature and exploring how it fits within Venmo's current ecosystem. I was asked to redesign a finance based app for an interview, and this is my solution."}
                                                TagWork={"Side project"}
                                                TagLocation={"Design Challenge"}
                                            ></ProjectCardMobile>

                                            :

                                            <ProjectCard
                                                Theme={"#5d93d8"}
                                                TagColor={"#2F80ED"}
                                                ProjectImage={ImageVenmo}
                                                ProjTitle={"Redesigning Venmo's payments flow"}
                                                ProjDescription={"Redesigning Venmo to be more efficient in terms of transactions, as well as conceptualizing a potential recurring payments feature and exploring how it fits within Venmo's current ecosystem. I was asked to redesign a finance based app for an interview, and this is my solution."}
                                                TagWork={"Side project"}
                                                TagLocation={"Design Challenge"}
                                            ></ProjectCard>

                                        }
                                    </Link>
                                </Col>

                            </Row>
                        </Col>
                    </Row>
                </motion.div>
                <Row start="lg" style={{ marginTop: 64 }}>
                    <Col xs={5} xsOffset={2}>
                        <p style={styles.HeroDescription}>Built with <a style={{ padding: 4 }}>&#x1F499;</a>in LA using Typescript and React</p>
                        <p style={styles.HeroDescription}>Here are my links</p>
                    </Col>
                </Row>
            </Grid>
        </motion.div>
    )
}

export default Home;